module.exports = __webpack_public_path__ + "img/w4b.59181cc2.jpg";